import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './styles/Avatar.css'

export const Avatar = ({ src, bg = 'gray', ...rest }) => {
  const classes = {
    defaultIcon: classNames(styles.userIconWrapper, {
      [styles.whiteBg]: bg === 'white'
    })
  }

  return (
    <div className={classes.defaultIcon} {...rest}>
      <img alt='avatar' className={styles.image} src={src || `${CONFIG.assetsBaseURL}/images/icons/avatar.svg`} />
    </div>
  )
}

Avatar.propTypes = {
  src: PropTypes.string,
  bg: PropTypes.oneOf([
    'gray',
    'white'
  ])
}

export default Avatar
